import React from 'react';
import cn from 'classnames';

import RoundButton from '../UIkit/RoundButton';

import style from './CardScroll.module.css';

type Props = {
  currentIndex: number;
  length: number;
  onClickNextHandler: () => void;
  onClickPrevHandler: () => void;
};

function CardScroll({ currentIndex, length, onClickPrevHandler, onClickNextHandler }: Props): JSX.Element {
  return (
    <div className={style.container}>
      <div className={style.steps}>
        <div className={style.text}>
          <div className={style.main}>0{currentIndex + 1}</div>
          <div className={style.greytext}> \ 0{length}</div>
        </div>
        <div className={style.line}>
          {new Array(length).fill(0).map((_, index) => {
            const isActive = index === currentIndex;
            return <div key={`CardScroll1__${index}`} className={cn(style.item, isActive && style.current)} />;
          })}
        </div>
      </div>
      <div className={style.btns}>
        <RoundButton pos={'left'} onClick={onClickPrevHandler} />
        <RoundButton pos={'right'} onClick={onClickNextHandler} />
      </div>
    </div>
  );
}

export default CardScroll;
